import React from "react";

const CandlePedicureBook = () => {
  return (
    <div className="nailSalonBookContainer">
      <h5>Book Your Candle Spa Manicure Today</h5>
      <p>
        Ready to treat yourself to the ultimate pampering experience?{" "}
        <a href="https://scentlifestyle.com/nails-salon">Book your Candle Spa Pedicure in Bangalore at SCENT today</a>
        . Whether you're looking to relax, rejuvenate, or simply indulge in a
        luxurious treatment, our <a href="https://scentlifestyle.com/nails-salon">Candle Spa Pedicure in Bangalore</a>{" "}
        is the perfect choice.
      </p>
      <p>
        Visit our website or call us to schedule your appointment. We look
        forward to welcoming you to <a href="https://scentlifestyle.com/">SCENT</a> and providing you with
        an unforgettable spa experience.
      </p>
    </div>
  );
};

export default CandlePedicureBook;
